import styled from 'styled-components';
import { grey, tabsBorder, tertiaryGrey } from 'styles/Colors';

export const Tile = styled.div`
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid ${tabsBorder};
  font-family: Lato;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
`;

export const Title = styled.div`
  color: ${tertiaryGrey};
  font-size: 13px;
  font-weight: 400;
  line-height: 18.2px;
`;

export const CurrentState = styled.div`
  color: ${grey};
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: 21px;
  display: flex;
  gap: 8px;
`;
